import { z } from "zod";

export const OneTimePasswordRequestFormSchema = z.object({
	email: z
		.string({ required_error: "Bitte gib eine E-Mail Adresse ein." })
		.email("Bitte gib eine gültige E-Mail Adresse ein."),
});
